import React from "react";
import "./styles/PaymentSuccess.css";
import SEO from "./SEO";
import { APP_NAME } from "../common/constants";

const PaymentSuccess: React.FC = () => {
  return (
    <>
      <SEO
        title={`Payment Successful – ${APP_NAME}`}
        description={`Thank you for your purchase! Your access to premium features on ${APP_NAME} has been successfully activated.`}
      />
      <div className="payment-success-container">
        <div className="payment-success-card">
          <h1 className="payment-success-title">🎉 Payment Successful!</h1>
          <p className="payment-success-message">
            Thank you for your purchase. You will receive an email from us shortly with instructions!
          </p>
          <a href="/" className="payment-success-button">
            Go Back Home
          </a>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
